// extracted by mini-css-extract-plugin
export default {"OverviewWrapper":"WhyGTA_OverviewWrapper__zMZDB","InnerDiv":"WhyGTA_InnerDiv__Adsdw"};